var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('equipment-toolbar',{attrs:{"heading":"Equipment Apps"}}),_c('addon-app-tab',{attrs:{"ui-location":"Equipment Module"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }